class Nodo
{
    constructor(id, patro_id, kategorio, ordo, publika, fina, kategorioj)
    {
        this.id = id;
        this.patro_id = patro_id;
        this.kategorio = kategorio;
        this.fina = fina;
        this.ordo = ordo;
        this.publika = publika;
        this.vortoj = new Map();
        this.kategorioj = kategorioj;
    }

    aldonuVorton(vorto)
    {
        var lingvo = vorto.lingvo;
        var vortojPorLingvo;

        if (this.vortoj.has(lingvo))
        {
            vortojPorLingvo = this.vortoj.get(lingvo);
        } else
        {
            vortojPorLingvo = [];
            this.vortoj.set(lingvo, vortojPorLingvo);
        }

        vortojPorLingvo.push(vorto);
    }

    enhavasVortojPorLingvo(lingvo)
    {
        return (this.vortoj.has(lingvo));
    }

    vortojPorLingvo(lingvo)
    {
        if (this.enhavasVortojPorLingvo(lingvo))
        {
            return (this.vortoj.get(lingvo));
        } else
        {
            return ([]);
        }
    }
}

export default Nodo;